import { useEffect } from "react";
import { FieldValues, UseFormReturn, useFormState } from "react-hook-form";

export const useFormUnsavedChangesWarning = <TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>,
) => {
  const { isDirty, isSubmitted } = useFormState({ control: form.control });

  useEffect(() => {
    const beforeUnload = (ev: Event) => {
      const hasChanges = isDirty && !isSubmitted;
      if (hasChanges) {
        ev.preventDefault();
      }
      return hasChanges;
    };

    window.addEventListener("beforeunload", beforeUnload);

    return () => {
      window.removeEventListener("beforeunload", beforeUnload);
    };
  }, [isDirty, isSubmitted]);
};
